import React, { useEffect, useRef } from 'react';
import { View, StyleSheet } from 'react-native';
import BMNotificationBannerManager, { NotificationBannerContainer } from './';
// this provider provide instance for the Notification Banner so that it can be used later using NotificationBanner.show(args) / NotificationBanner.close()
function BMNotificationBannerProvider(props) {
    const containerRef = useRef(null);
    const { style, children, ...restProps } = props;
    useEffect(() => {
        if (BMNotificationBannerManager.instance) {
            throw new Error('Notification Banner instance should be only one instance within one page');
        }
        else {
            if (containerRef.current) {
                BMNotificationBannerManager.instance = containerRef.current;
            }
        }
        return () => {
            BMNotificationBannerManager.instance = null;
        };
    }, []);
    return (<View style={[styles.container, style]}>
      {children}
      <NotificationBannerContainer ref={containerRef} {...restProps}/>
    </View>);
}
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
export default BMNotificationBannerProvider;
